<template>
<Layout>
  <div class="home">
     </div>
     <h1>Test</h1>
    </Layout>
 
</template>

<script>

import Layout from '../components/Layout'

export default {
  name: 'test',
  components : {
    Layout
  }
}
</script>
